// TG GRACIAS A MI SEÑOR DIOS TG TG TG
// AboutMe.js
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import "./App.css";
import WhoAmIBg from "./images/who-am-i-eleven-fit-image-3-TG.png";

const AboutMe = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <main>
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.4 }}
        >
        {/* Hero Section — same image as the Who Am I section */}
        <section
          id="about"
          className="section overlay tint-black-40"
          style={{
            height: "auto",
            padding: 0,
            flexDirection: "column",
            justifyContent: "flex-start",
            backgroundImage: "none",
          }}
        >
          <img
            src={WhoAmIBg}
            alt="Oscar - Eleven.fit"
            style={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
          <div
            className="section__content"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <h2 className="general-title">About Me</h2>
            <h2 className="font-size-20 color-gray-3">
              functional fitness coach &amp; founder
            </h2>
          </div>
        </section>

        {/* Bio Section */}
        <section className="section-2 bg-image-floor overlay tint-black-50">
          <div className="section__content">
            <div className="gdiv width-80 gap-20px">
              <h2 className="general-title text-align-left move-left text-shadow">
                Oscar — Eleven.fit
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <p className="margin-bottom-20">
                  Hey there! I'm Oscar, a functional fitness coach on a mission
                  to help people get fit for life. I've been training since
                  2016 and have worked with dozens of athletes, beginners, and
                  everyone in between.
                </p>

                <p className="margin-bottom-20">
                  My philosophy is simple: <strong>consistency beats intensity.</strong>{" "}
                  You don't need crazy workouts or expensive gear — you just
                  need the right guidance and the will to show up.
                </p>

                <p className="margin-bottom-20">
                  Through Eleven.fit, I've built a training ecosystem that
                  includes a full workout timer app, personalized programs, and
                  a community of people who push each other every single day.
                </p>
              </div>
            </div>

            {/* What I Offer */}
            <div className="gdiv width-80 gap-20px margin-top-100">
              <h2 className="general-title text-align-left move-left text-shadow">
                What I Bring
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <ul>
                  <li className="margin-bottom-20">
                    <strong className="color-1">🔥 Functional Training</strong>{" "}
                    — Workouts that mimic real-life movements, building
                    strength you can actually use.
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">📱 Eleven.fit App</strong>{" "}
                    — A no-install-needed web app with timers, workouts, and
                    tracking for every session.
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">📦 Programs &amp; Packs</strong>{" "}
                    — Structured plans for hypertrophy, calorie burn, abs,
                    and full-body conditioning.
                  </li>
                  <li className="margin-bottom-20">
                    <strong className="color-1">💬 Coaching &amp; Support</strong>{" "}
                    — Direct access to ask me anything about your form, your
                    diet, or your next PR.
                  </li>
                </ul>
              </div>
            </div>

            {/* Fun Facts */}
            <div className="gdiv width-80 gap-20px margin-top-100 margin-bottom-100">
              <h2 className="general-title text-align-left move-left text-shadow">
                Fun Facts
              </h2>

              <div className="general-description text-align-left move-left text-shadow margin-top-20">
                <ul>
                  <li className="margin-bottom-20">
                    🏋️ Started training in a garage with a single rusty kettlebell.
                  </li>
                  <li className="margin-bottom-20">
                    🌎 I've coached people from Guatemala, the US, Mexico, and beyond.
                  </li>
                  <li className="margin-bottom-20">
                    🎵 I can't workout without good music — it's 50% of the gain.
                  </li>
                  <li className="margin-bottom-20">
                    ☕ My best ideas come after the first cup of coffee.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        </motion.div>
      </main>
    </div>
  );
};

export default AboutMe;
